import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import { isPuXing } from '@/utils/fn'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    keepAlive: true              if set cache
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => isPuXing() ? import('@/views/login/px_index') : import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/401'),
    hidden: true
  },
  {
    path: '/findpass',
    component: () => import('@/views/login/findpass.vue'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/register/index.vue'),
    hidden: true
  },
  {
    path: '/msg',
    component: Layout,
    name: 'Msg',
    redirect: '/msg/index',
    hidden: true,
    children: [{
      path: 'index',
      name: 'MsgIndex',
      component: () => import('@/views/message/index'),
      meta: { title: '消息' }
    }]
  },
  {
    path: '/',
    component: Layout,
    name: 'Home',
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'Homeindex',
      component: () => isPuXing() ? import('@/views/home/px_index') : import('@/views/home/index'),
      meta: { title: '首页', icon: 'shouye' }
    }]
  },
  {
    path: '/pay',
    component: Layout,
    name: 'Pay',
    redirect: '/pay/list',
    meta: { title: '订单管理', icon: 'zhifu' },
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'PayTist',
      component: () => import('@/views/pay/list'),
      meta: { title: '订单列表', keepAlive: true, code: '6d2ad5c727c4b5b7141d5a455f5e33b4' }
    }, {
      path: 'check',
      name: 'PayCheck',
      component: () => import('@/views/pay/payCheck'),
      meta: { title: '对账中心', code: '721faca850b533472cb334f0fa3d402a' }
    }]
  },
  {
    path: '/trade',
    component: Layout,
    name: 'Trade',
    redirect: '/trade/record',
    meta: { title: '交易管理', icon: 'jiaoyi' },
    alwaysShow: true,
    children: [{
      path: 'refund',
      name: 'Refund',
      component: () => import('@/views/trade/refund'),
      meta: { title: '资金管理', keepAlive: true, code: 'eda556dbf470cc1cca442829e176028c' }
    },
    { // 资金管理-充值详情
      path: '/interconvert',
      name: 'interconvert',
      component: () => import('@/views/trade/interconvert'),
      hidden: true,
      meta: { title: '商户号互转详情', keepAlive: true, code: 'eda556dbf470cc1cca442829e176028c' }

    },
    { // 资金管理-充值详情
      path: '/payee_detail',
      name: 'payee_detail',
      component: () => import('@/views/trade/payee_detail'),
      hidden: true,
      meta: { title: '资金管理充值详情', keepAlive: true, code: 'eda556dbf470cc1cca442829e176028c' }

    }, { // 资金管理-退款详情
      path: '/refund_detail',
      name: 'refund_detail',
      component: () => import('@/views/trade/refund_detail'),
      hidden: true,
      meta: { title: '资金管理退款详情', keepAlive: true, code: 'eda556dbf470cc1cca442829e176028c' }
    }, {
      path: 'moneyWater',
      name: 'MoneyWater',
      component: () => import('@/views/trade/moneyWater'),
      meta: { title: '资金流水' }
    }
    ]
  },
  {
    path: '/mch',
    component: Layout,
    name: 'Mch',
    redirect: '/mch/list',
    meta: { title: '商户号管理中心', icon: 'shanghuhao' },
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'MchList',
      component: () => import('@/views/mch/index'),
      meta: { title: '商户号管理', code: 'dee6d8711f8a1ca85c3063cda1d333be' }
    }, {
      path: 'appId',
      name: 'AppId',
      component: () => import('@/views/mch/appIdManage'),
      meta: { title: 'APPID账号管理', code: '74d6b0d5504a2718f8e092926682789c' }
    }]
  },
  {
    path: '/invoice',
    component: Layout,
    name: 'Invoice',
    redirect: '/invoice/bill',
    meta: { title: '开票管理', icon: 'kaipiao' },
    alwaysShow: true,
    children: [
      {
        path: 'account_check_manage',
        name: 'account_check_manage',
        component: () => import('@/views/invoice/accountCheckManage'),
        meta: { title: '对账管理', code: 'a00483d5f87a80bce41434e86116b5f8' }
      },
      //   {
      //   path: 'bill',
      //   name: 'Bill',
      //   component: () => import('@/views/invoice/index'),
      //   meta: { title: '开票中心', code: '7f168f3537dde61999800f79d4d19ee4' }
      // },
      { // 开票记录
        path: 'bill_manage',
        name: 'BillManage',
        meta: { title: '开票记录', code: '43623d154d4607e868045db64e47ce05', keepAlive: true },
        component: () => import('@/views/invoice/billManage.vue')
      },
      { // 开票信息
        path: 'bill_info',
        name: 'billInfo',
        meta: { title: '开票信息', code: '91d723bca1b1aa2f7a2e825d7db2fc9e' },
        component: () => import('@/views/invoice/billInfo.vue')
      },
      { // 开票记录详情
        path: 'bill_detail',
        name: 'bill_detail',
        component: () => import('@/views/invoice/billDetail.vue'),
        hidden: true,
        meta: { title: '开票详情', activeMenu: '/invoice/billDetail', code: '072866b400538d17f4c0bc5e44062011' }
      },
      { // 印章管理
        path: 'seal_manage',
        name: 'seal_manage',
        meta: { title: '印章管理', code: '786852f24929ee42e4bb2b2f5ba6a815' },
        component: () => import('@/views/invoice/sealManage.vue')
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    name: 'Account',
    redirect: '/account/compay_info',
    meta: { title: '账号资料', icon: 'zhanghao' },
    alwaysShow: true,
    children: [{
      path: 'compay_info',
      name: 'CompayInfo',
      component: () => import('@/views/account/compayInfo'),
      meta: { title: '企业资料', code: '09a7722724730b2590a6a0540f3a93a4' }
    }, {
      path: 'employee',
      name: 'Employee',
      component: () => import('@/views/account/employee'),
      meta: { title: '操作员管理', activeMenu: '/account/employee', code: 'b5eaf481d0cb9a394b7410c2f559b40f' }
    }, {
      path: 'role',
      name: 'Role',
      component: () => import('@/views/account/role'),
      hidden: true,
      meta: { title: '角色管理', activeMenu: '/account/employee' }
    }, {
      path: 'power',
      name: 'Power',
      hidden: true,
      component: () => import('@/views/account/power'),
      meta: { title: '权限配置', activeMenu: '/account/employee' }
    }]
  },
  {
    path: '/set',
    component: Layout,
    name: 'Set',
    redirect: '/set/index',
    meta: { title: '设置', icon: 'shezhi' },
    alwaysShow: true,
    children: [{
      path: 'index',
      name: 'Index',
      component: () => import('@/views/set/index'),
      meta: { title: '开发设置', code: '918c944c3c4806b1194e17154d243cf7' }
    }, {
      path: 'messageSet',
      name: 'MessageSet',
      component: () => import('@/views/set/messageSet'),
      meta: { title: '消息设置' }
    }, {
      path: 'version',
      name: 'Version',
      component: () => import('@/views/set/version'),
      meta: { title: '版本更新记录', activeMenu: '/set/version' }
    },
    {
      path: 'balanceSet',
      name: 'balanceSet',
      component: () => import('@/views/set/balanceSet'),
      meta: { title: '余额预警配置' }
    }]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
